export enum FieldTypes {
    SingleLineOfText = 1,
    MultipleLinesOfText,
    Lookup,
    Number,
    Person,
    Choice
}

export enum ChoiceFieldTypes {
    DropDownMenu = 1,
    RadioButtons
}